import React from "react";
import styles from "./home.module.css";
import Navbar from "../../Components/Navbar/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import { MdOutlineArrowOutward } from "react-icons/md";
import Leaders from "../../Components/Leaders/Leaders";
import ScreenCard from "../../Components/ScreenCard/ScreenCard";
import VisionSection from "../../Components/Vision/VisionSection";
import ImageSection from "../../Components/ImageSection/ImageSection";
import SwiperSlider from "../../Components/SwiperSlider/SwiperSlider";
import { Link, useNavigate } from "react-router-dom";


const Home = () => {
  const navigate = useNavigate()
  return (
    <React.Fragment>
      <div className={styles.main_section}>
        <Navbar />

        <Container>
          <Row>
            <Col sm={12} md={6}>
              <div className={styles.left_section}>
                <h6>Leading Solar Energy Provider In India Distributed and Plant services</h6>
                <p>
                  Forem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </p>
                <button onClick={() => navigate(`/about`)}>
                  Learn More <MdOutlineArrowOutward  />
                </button>
              </div>
            </Col>
            {/* <Col sm={12} md={6}>
              <div className={styles.right_section}>
                <p>
                  Forem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </p>
                <p>
                  Forem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos.
                </p>
                <span>
                  {" "}
                  View details <MdOutlineArrowOutward />{" "}
                </span>
              </div>
            </Col> */}
          </Row>
          <ScreenCard/>

        </Container>
      </div>

      
      <div className={styles.hero_section}>
        <Container>
          <Row>
            <Col sm={12} md={6}>
              <h6>Global Presence, Local Impact</h6>
              <p>
                Connecting continents with trust, quality, and
                innovation—spanning India, Nepal, UAE, UK, and USA.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <div className={styles.container_section}>
        <Container>
          <Row>
            <Col sm={12} md={6}>
              <div className={styles.left_section}>
                <h6>Building Bridges Across Borders</h6>
                <p>
                  Empowering global trade with trust, innovation, and seamless
                  solutions across five nations.
                </p>
                <span>
                  {" "}
                  Read More <MdOutlineArrowOutward />
                </span>
              </div>
            </Col>
            <Col sm={12} md={6}>
              <div className={styles.right_section}>
                <p>
                  At CrossBorder BTC, we are a multinational business committed
                  to connecting buyers and suppliers worldwide. Specializing in
                  a diverse range of commodities, we serve industries spanning
                  natural resources, electronics, food, and more.
                </p>
                <p>
                  With a presence in India, Nepal, UAE, UK, and the USA, our
                  operations are built on trust, quality, and innovation.
                  Whether it’s participating in government tenders or delivering
                  end-to-end solutions, we take pride in simplifying global
                  trade and creating value for our clients.
                </p>

                <p>
                  Our mission is clear: to empower businesses through reliable
                  partnerships, seamless transactions, and a steadfast
                  dedication to excellence.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* -----------solution-section-start------------ */}

      <Container>
        <Row>
          <Col md={6} sm={12}>
            <div className={styles.solution_section}>
              <h6>
                Comprehensive Solutions for <br /> Every Need
              </h6>
              <span>
                Explore our diverse range of products and services designed to
                empower <br /> industries worldwide.
              </span>
              <p>
                From natural resources like coal, minerals, and solar energy to
                advanced electronics, healthcare devices, and luxury essentials,
                we deliver quality products tailored to your needs. Our
                portfolio extends to innovative services like immigration
                support, government project participation, and cutting-edge
                technology transfers.
              </p>
              <Link to={'/product'}>
                Explore Now <MdOutlineArrowOutward />
              </Link>
            </div>
          </Col>
        </Row>
        <SwiperSlider />
      </Container>

      {/* -----------solution-section-end------------ */}

      {/* -----------Image-section-start------------ */}
      <ImageSection />
      {/* <ImageSec /> */}
      {/* -----------Image-section-end------------ */}

      {/* -------------vision-section-start------------- */}
      <VisionSection />
      {/* -------------vision-section-end------------- */}
      {/* -------------leader-section-start------------- */}
      <Leaders />

      {/* -------------leader-section-end------------- */}

    </React.Fragment>
  );
};

export default Home;
